// src/shared/ui/EmptyState.jsx
//
// Generalizes the "No data to display" text-only pattern already
// parameterized in DataTable's `emptyMessage` prop, but hand-written
// (usually just a plain <p>) in every other list/table/panel across
// modules when there's nothing to show yet.
//
// Usage:
//   <EmptyState title="No deployments yet" description="Start one to see it here." />
//   <EmptyState icon={Inbox} title="No results" action={<Button onClick={reset}>Clear filters</Button>} />

import PropTypes from "prop-types";

export default function EmptyState({ icon: Icon, title, description, action, className = "" }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center gap-1.5 py-12 px-6 ${className}`.trim()}>
      {Icon && (
        <div className="mb-2 flex items-center justify-center w-10 h-10 rounded-full bg-gray-100 text-muted">
          <Icon size={18} />
        </div>
      )}
      <p className="text-sm font-semibold text-ink">{title}</p>
      {description && <p className="text-sm text-muted max-w-sm">{description}</p>}
      {action && <div className="mt-3">{action}</div>}
    </div>
  );
}

EmptyState.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.node.isRequired,
  description: PropTypes.node,
  action: PropTypes.node,
  className: PropTypes.string,
};
